<div class="lead-page">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>Sales & Installation Partners</h2>
        <p>Track vendors, integrators, installers, and local referral partners.</p>
      </div>
      <div class="lead-actions">
        <button class="lead-btn" (click)="openCreate()">Add Partner</button>
      </div>
    </div>

    <div class="lead-filters">
      <div class="lead-filter-field">
        <label>Search</label>
        <input [(ngModel)]="filters.search" placeholder="Company / contact / mobile" />
      </div>
      <div class="lead-filter-field">
        <label>Status</label>
        <select [(ngModel)]="filters.status">
          <option value="">All Status</option>
          <option *ngFor="let option of statuses" [value]="option[0]">{{ option[1] }}</option>
        </select>
      </div>
      <div class="lead-filter-field">
        <label>Business Type</label>
        <select [(ngModel)]="filters.business_type">
          <option value="">All Types</option>
          <option *ngFor="let option of businessTypes" [value]="option[0]">{{ option[1] }}</option>
        </select>
      </div>
      <div class="lead-filter-field">
        <label>City</label>
        <input [(ngModel)]="filters.city" placeholder="City" />
      </div>
      <div class="lead-filter-field">
        <label>State</label>
        <input [(ngModel)]="filters.state" placeholder="State" />
      </div>
    </div>

    <div class="inline-actions">
      <button class="lead-btn-secondary" (click)="applyFilters()">Apply Filters</button>
      <button class="lead-btn-muted filter-reset-btn" (click)="resetFilters()">Reset</button>
    </div>

    <div class="lead-loading" *ngIf="loading">Loading partners...</div>

    <div class="lead-table-wrap" *ngIf="!loading">
      <table class="lead-table">
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Contact Person</th>
            <th>Mobile</th>
            <th>City</th>
            <th>Business Type</th>
            <th>Status</th>
            <th>Leads Count</th>
            <th>Organizations Count</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!partners.length">
            <td colspan="10" class="lead-empty">No sales and installation partners found.</td>
          </tr>
          <tr *ngFor="let partner of partners">
            <td>{{ partner.company_name }}</td>
            <td>{{ partner.contact_person || '-' }}</td>
            <td>{{ partner.mobile_number }}</td>
            <td>{{ partner.city || '-' }}</td>
            <td>{{ partner.business_type_label || '-' }}</td>
            <td>
              <span
                class="lead-status"
                [ngClass]="partner.status === 'ACTIVE' ? 'ACTIVE' : 'sales-partner-non-active'">
                {{ partner.status_label }}
              </span>
            </td>
            <td>{{ partner.leads_count || 0 }}</td>
            <td>{{ partner.organizations_count || 0 }}</td>
            <td>{{ partner.created_at | date: 'dd/MM/yyyy' }}</td>
            <td class="table-actions-cell">
              <div class="table-actions">
                <button class="action-button" type="button" (click)="openView(partner)" title="View" aria-label="View">
                  <fa-icon [icon]="['fas', 'eye']"></fa-icon>
                </button>
                <button class="action-button bt-edit" type="button" (click)="openEdit(partner)" title="Edit" aria-label="Edit">
                  <fa-icon [icon]="['fas', 'pen']"></fa-icon>
                </button>
                <button *ngIf="isSuperUser" class="action-button bt-delete" type="button" (click)="openDelete(partner)" title="Delete" aria-label="Delete">
                  <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer">
      <div class="total-records">Total Records: {{ totalRecords }}</div>
      <div class="pagination-controls">
        <label for="sip-page-size">Records per page</label>
        <select id="sip-page-size" [(ngModel)]="pageSize" (change)="selectPageSize()">
            <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
        </select>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m15 18-6-6 6-6"/></svg>
        </button>
        <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m9 18 6-6-6-6"/></svg>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showDeleteModal">
  <div class="lead-modal">
    <div class="lead-title">
      <h3>Delete Sales & Installation Partner</h3>
      <p>Are you sure you want to delete this Sales & Installation Partner?</p>
    </div>
    <div class="inline-actions">
      <button class="lead-btn-muted" (click)="closeDeleteModal()">Cancel</button>
      <button class="lead-btn-danger" (click)="confirmDelete()" [disabled]="deleting">
        {{ deleting ? 'Deleting...' : 'Delete' }}
      </button>
    </div>
  </div>
</div>
